




















































































/* Created- 19 - Aug - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ConversionLogModel, IConversionLogModel } from "../../Generated/ParticaAPI";
import ParticaCardDialog from "../Common/Container/ParticaDialogCard.vue";
@Component(
	{
		name: "IssueConversionLog",
		components: { ParticaCardDialog }
	})
export default class IssueConversionLog extends Vue {
	@Prop() private data: ConversionLogModel[]; // your data   
	private selected: ConversionLogModel = new ConversionLogModel();
	private showstats: boolean = false;
	private headers: any[] = [
		{ text: "Start", value: "start", sortable: true },
		{
			text: "End",
			align: "left",
			sortable: true,
			value: "end"
		},
		{ text: "Pages", value: "pages", sortable: true },
		{ text: "Message", value: "message", sortable: true },
	];
	private getColor(log: ConversionLogModel): string {
		if (log.message === null) {
			return "lightgreen";
		}
		return "pink"; // error
	}
	private showProps(data: ConversionLogModel) {
		this.selected = data;
		this.showstats = true;
	}

	private getProcessingTime(selected: ConversionLogModel): string {
		if (selected !== undefined) {
			let t: number = (selected.xod as number) + (selected.thumbnail as number) + (selected.download as number);
			t += (selected.preflight as number) + (selected.extract as number) + (selected.wordsmart as number) + (selected.merge as number);
			const m: number = t / 1000;
			return m.toFixed();
		}
		return "unknown";
	}
}



